import type { ReactElement } from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import type { BrowserAiToolsTrendCategory } from '@kirin/api-client/contracts/shadow-ai-browser-tools';

export const TREND_CONFIG: Record<
  BrowserAiToolsTrendCategory,
  { label: string; className: string; icon?: ReactElement }
> = {
  new: {
    label: 'New',
    className: 'text-blue-600',
  },
  resumed: {
    label: 'Resumed',
    className: 'text-yellow-600',
    icon: <TrendingUp className="h-3 w-3" />,
  },
  increasing: {
    label: 'Increasing',
    className: 'text-green-600',
    icon: <TrendingUp className="h-3 w-3" />,
  },
  stable: {
    label: 'Stable',
    className: 'text-muted-foreground',
    icon: <Minus className="h-3 w-3" />,
  },
  decreasing: {
    label: 'Decreasing',
    className: 'text-red-600',
    icon: <TrendingDown className="h-3 w-3" />,
  },
  inactive: {
    label: 'Inactive',
    className: 'text-muted-foreground',
  },
};
